/* eslint-disable react/no-danger-with-children */
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState } from "react";

import { SocialSignUpType } from "../../../api/types/social.type";
import { FidelityTranslations } from "../../../api/types/translations";
import { translationsContent } from "../../../localization/translations";
import { useLanguage } from "../../../store/lang.context";
import { translate } from "../../../utils/translate";
import Login from "../../auth/Login";
import Signup from "../../auth/Signup";
import SocialSignUp from "../../auth/SocialSignup";
import classes from "./intro.module.scss";

interface Props {
  translations: FidelityTranslations[];
}

const Intro = ({ translations }: Props) => {
  const { language } = useLanguage();
  const isMobile = useMediaQuery("(max-width: 750px)");
  const [loginModalIsOpen, setLoginModalIsOpen] = useState(false);
  const [socialLoginModalIsOpen, setSocialLoginModalIsOpen] =
    useState<SocialSignUpType>({
      id: 0,
      open: false,
    });
  const [signupModalIsOpen, setSignupModalIsOpen] = useState(false);

  const openLoginPopup = () => {
    setLoginModalIsOpen(true);
  };
  return (
    <div className={classes.container}>
      <div
        className={classes.intro}
        style={{
          backgroundImage: isMobile
            ? "url('/assets/ui/backgroundCover.jpg')"
            : "url('/assets/ui/backgroundCover.jpg')",
        }}
      >
        <div className={classes.item}>
          <div className={classes.fideliteTitle}>Fidélité</div>
          {/* <div
            dangerouslySetInnerHTML={{
              __html: translations[0]["first_block_title_" + language],
            }}
          /> */}
          <div
            dangerouslySetInnerHTML={{
              __html: translations[0]["first_block_content_" + language],
            }}
          />
          {/* <div
            className={classes.innerContainer}
            onClick={() => {
              document
                .getElementById("commitmentsDiv")
                ?.scrollIntoView({ behavior: "smooth", block: "center" });
            }}
          ></div> */}
          <div>
            <button className={classes.registerButton} onClick={openLoginPopup}>
              {translate(translationsContent, "buttonContent", language)}
            </button>
            {loginModalIsOpen && (
              <Login
                setLoginIsOpen={setLoginModalIsOpen}
                setSignUpIsOpen={setSignupModalIsOpen}
                setSocialSignUp={setSocialLoginModalIsOpen}
              />
            )}
            {socialLoginModalIsOpen.open && (
              <SocialSignUp
                setSignUpIsOpen={setSignupModalIsOpen}
                setLoginIsOpen={setLoginModalIsOpen}
                socialSignUp={socialLoginModalIsOpen}
                setSocialSignUp={setSocialLoginModalIsOpen}
              />
            )}
            {signupModalIsOpen && (
              <Signup
                setLoginIsOpen={setLoginModalIsOpen}
                setSignUpIsOpen={setSignupModalIsOpen}
                setSocialSignUp={setSocialLoginModalIsOpen}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Intro;
